import types from './types';

const runAssessment = (projectId, payload) => ({
  type: types.RUN_ASSESSMENT,
  payload: { projectId, payload },
});
const runAssessmentSuccess = result => ({
  type: types.RUN_ASSESSMENT_SUCCESS,
  payload: result,
});
const runAssessmentFailure = error => ({
  type: types.RUN_ASSESSMENT_FAILURE,
  payload: error,
});

const getAssessments = projectId => ({
  type: types.GET_ASSESSMENTS,
  payload: projectId,
});
const getAssessmentsSuccess = assessments => ({
  type: types.GET_ASSESSMENTS_SUCCESS,
  payload: assessments,
});
const getAssessmentsFailure = error => ({
  type: types.GET_ASSESSMENTS_FAILURE,
  payload: error,
});

const setDraft = (projectId, draft) => ({
  type: types.SET_DRAFT,
  payload: { projectId, draft },
});
const hydrateDraft = projectId => ({
  type: types.HYDRATE_DRAFT,
  payload: projectId,
});

const getTopFeatures = (projectId, topN = 5) => ({
  type: types.GET_TOP_FEATURES,
  payload: { projectId, topN },
});
const getTopFeaturesSuccess = features => ({
  type: types.GET_TOP_FEATURES_SUCCESS,
  payload: features,
});
const getTopFeaturesFailure = error => ({
  type: types.GET_TOP_FEATURES_FAILURE,
  payload: error,
});

// Higher Ed Surveys

const getSurveys = projectId => ({
  type: types.GET_SURVEYS,
  payload: projectId,
});
const getSurveysSuccess = surveys => ({
  type: types.GET_SURVEYS_SUCCESS,
  payload: surveys,
});
const getSurveysFailure = error => ({
  type: types.GET_SURVEYS_FAILURE,
  payload: error,
});

const createSurvey = (projectId, surveyName) => ({
  type: types.CREATE_SURVEY,
  payload: { projectId, surveyName },
});
const createSurveySuccess = survey => ({
  type: types.CREATE_SURVEY_SUCCESS,
  payload: survey,
});
const createSurveyFailure = error => ({
  type: types.CREATE_SURVEY_FAILURE,
  payload: error,
});

const getSurveyDetails = surveyId => ({
  type: types.GET_SURVEY_DETAILS,
  payload: surveyId,
});
const getSurveyDetailsSuccess = details => ({
  type: types.GET_SURVEY_DETAILS_SUCCESS,
  payload: details,
});
const getSurveyDetailsFailure = error => ({
  type: types.GET_SURVEY_DETAILS_FAILURE,
  payload: error,
});
const resetSurveyDetails = () => ({
  type: types.RESET_SURVEY_DETAILS,
});

const answerSurvey = (surveyId, capabilitiesValues) => ({
  type: types.ANSWER_SURVEY,
  payload: { surveyId, capabilitiesValues },
});
const answerSurveySuccess = () => ({
  type: types.ANSWER_SURVEY_SUCCESS,
});
const answerSurveyFailure = error => ({
  type: types.ANSWER_SURVEY_FAILURE,
  payload: error,
});

const removeSurvey = (projectId, surveyId) => ({
  type: types.REMOVE_SURVEY,
  payload: { projectId, surveyId },
});
const removeSurveySuccess = () => ({
  type: types.REMOVE_SURVEY_SUCCESS,
});
const removeSurveyFailure = error => ({
  type: types.REMOVE_SURVEY_FAILURE,
  payload: error,
});

export default {
  runAssessment, runAssessmentSuccess, runAssessmentFailure,
  getAssessments, getAssessmentsSuccess, getAssessmentsFailure,
  setDraft, hydrateDraft,
  getTopFeatures, getTopFeaturesSuccess, getTopFeaturesFailure,
  getSurveys, getSurveysSuccess, getSurveysFailure,
  createSurvey, createSurveySuccess, createSurveyFailure,
  getSurveyDetails, getSurveyDetailsSuccess, getSurveyDetailsFailure, resetSurveyDetails,
  answerSurvey, answerSurveySuccess, answerSurveyFailure,
  removeSurvey, removeSurveySuccess, removeSurveyFailure,
};
